import { AfterViewInit, Component, ElementRef, ErrorHandler, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Business } from '../models/business.model';
import { QuickNavToc } from '../../shared/models/quick-nav-toc.model';
import { FlyingClubComponent } from '../flying-club/flying-club.component';
import { QuickNavComponent } from '../../shared/quick-nav/quick-nav.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { AirportService } from '../../airport/airport.service';
import { hasTag } from '../../util/tag-utils';
import { HelpDialogComponent } from '../help-dialog/help-dialog.component';
import { MatDialog } from '@angular/material';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
import { AuthService } from '../../auth/auth/auth.service';



@Component({
  selector: 'app-flyingclub-detail',
  templateUrl: './flyingclub-detail.component.html',
  styleUrls: ['./flyingclub-detail.component.scss']
})
export class FlyingclubDetailComponent implements OnInit, AfterViewInit {
  @Input() business: Business;
  isBusinessOwner = false;
  isFlightDeckAdmin = false;
  editModeSet = false;
  isAmbassador = false;
  isNotApproved = false;

  @ViewChild('quicknav') quicknav: QuickNavComponent;
  @ViewChild('body', { read: ElementRef }) body: ElementRef;
  @ViewChild(FlyingClubComponent) clubSection: FlyingClubComponent;

  toc: QuickNavToc = new QuickNavToc('fbo-quicknav', [{
    label: 'Overview',
    fragment: 'overview',
    visible: true
  }, {
    label: 'Contact Info',
    fragment: 'contacts',
    visible: true
  }, {
    label: 'Flying Club Info',
    fragment: 'club',
    visible: () => this.clubSection.hasContent
  }]);

  constructor (private _route: ActivatedRoute,
              private _errorHandler: ErrorHandler,
              private businessManagerService: BusinessManagerService,
              private _toggleService: EditToggleService,
              private _airportService: AirportService,
              private _matDialog: MatDialog,
              private _analyticsService: AnalyticsService,
              private _auth: AuthService) {
  }

  async ngOnInit() {
    this._route.data
      .subscribe((data: { business: Business }) => {
        this.business = data.business;
      }, (error: any) => {
        this._errorHandler.handleError(error);
      });
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
    this.isBusinessOwner = await this.businessManagerService.userOwnsBusiness(this.business.id);
    this.isFlightDeckAdmin = await this.businessManagerService.isFlightDeckAdmin();
    if (hasTag(this.business.tags, 'Flying Club') && this.business.flyingClub) {
      this.isAmbassador = await this.businessManagerService.isAmbassador();
    }
    this.isNotApproved = hasTag(this.business.tags, 'Admin::BusinessNotApproved');
    this._analyticsService.pageView('airport_flyingclub', 'Flying Club Detail');
    this._analyticsService.trackEvent('airport_flyingclub_viewed', this.business.id.toString(), this.business.id.toString());
    if (this._auth.authenticated && this._auth.endUser) {
      this._analyticsService.trackEvent('airport_flyingclub_loggedin', this._auth.recid, this._auth.recid);
    } else {
      this._analyticsService.trackEvent('airport_flyingclub_loggedout', '', '');
    }
  }

  async onReloadBusiness(reload: boolean) {
    this.business = await this._airportService.getBusiness(this.business.id.toString());
  }

  ngAfterViewInit() {
    /*
    const $detailBody = $(this.body.nativeElement);
    const $page = $detailBody.closest('.detail-page');
    this.quicknav.setContainerHeight($page.height() + 1000);
    */
    if (hasTag(this.business.tags, 'Admin::BusinessNotApproved')) {
      this.showHelp();
    }
  }

  showHelp() {
    const dialogRef = this._matDialog.open(HelpDialogComponent, {
      data: {
        businessType: 'Flying Club'
      }
    });
  }
}
